import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ContentLocalities" */'@modals/partials/ContentLocalities'));
